// extracted by mini-css-extract-plugin
module.exports = {"active":"Pagination_active__3wxEy"};